import { put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getAssessmentSelector } from '../selectors'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { IAssessmentState } from '../store/assessment.types'
import { AssessmentConstants } from '../store/assessment.constant'
import { saveAssessment, setCustomAssessmentsFields, setUpdateInputRows } from '../store/assessment.actions'
import { ProcedureConstants } from '../../../../components/procedure/store/procedure.constants'

export function* setCustomFieldOptions() {
  const assessmentState: IAssessmentState = yield select(getAssessmentSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const { _customFieldOption, customAssessmentsFields } = assessmentState
      const updatedCustomAssessmentsFields =
        customAssessmentsFields && customAssessmentsFields.length ? [...customAssessmentsFields] : []

      if (_customFieldOption && !!_customFieldOption.value) {
        const option = {
          fieldId: _customFieldOption.fieldId,
          value: _customFieldOption.value,
          responseType: _customFieldOption.responseType,
        }
        const currentCustomFieldIndex = updatedCustomAssessmentsFields?.findIndex(
          (data) => data.fieldId === _customFieldOption.fieldId
        )
        if (currentCustomFieldIndex > -1) {
          updatedCustomAssessmentsFields[currentCustomFieldIndex] = option
        } else {
          updatedCustomAssessmentsFields.push(option)
        }
        yield put(setCustomAssessmentsFields(updatedCustomAssessmentsFields))
      } else {
        const currentCustomFieldIndex = updatedCustomAssessmentsFields?.findIndex(
          (data) => data.fieldId === _customFieldOption?.fieldId
        )
        if (currentCustomFieldIndex > -1) {
          updatedCustomAssessmentsFields.splice(currentCustomFieldIndex, 1)
          yield put(setCustomAssessmentsFields(updatedCustomAssessmentsFields))
        }
      }
      if (
        _customFieldOption?.fieldType === ProcedureConstants.MULTI_SELECT ||
        _customFieldOption?.fieldType === ProcedureConstants.DATE
      ) {
        yield put(setUpdateInputRows(true))
      }
      yield put(saveAssessment())
    } catch (e) {
      yield put(throwPcrException(`setCustomFieldOptionSaga() error: ${e}`))
    }
  }
}
export function* setCustomFieldOptionSaga() {
  yield takeLatest([AssessmentConstants.SET_CUSTOM_FIELD_OPTION], performWithMutexHOG, setCustomFieldOptions)
}
